

document.querySelectorAll('.detailmodule_html *').forEach(el => {
    const html = el.innerHTML
        .replace(/&nbsp;/gi, '')
        .replace(/<br\s*\/?>/gi, '')
        .trim();

    if (html === '' && el.children.length === 0) {
        el.remove();
    }
});

document.querySelectorAll('.detailmodule_html div').forEach(div => {
    const html = div.innerHTML
        .replace(/&nbsp;/g, '')
        .replace(/<br\s*\/?>/gi, '')
        .trim();

    if (html === '') {
        div.remove();
    }
});